



























































import {
  defineComponent,
  PropType,
  ref,
} from '@vue/composition-api'

import HLine from '@/components/atoms/HLine.vue'
import DateSelect from '@/components/organisms/h/item/date/DateSelect.vue'
import ItemHierarchyGroup from '@/components/organisms/h/item/hierarchy/ItemHierarchyGroup.vue'
import ExtractConditionLayout from '@/components/organisms/h/layout/ExtractConditionLayout.vue'
import {
  OrderBudgetCreateExtractCondition,
  itemHierarchyGroupExtractCondition,
  itemHierarchyUseList,
  dateSelectExtractCondition,
} from '@/types/entities'
import { addDayYMD } from '@/utils/mixin'

export default defineComponent({
  components: {
    ExtractConditionLayout,
    ItemHierarchyGroup,
    HLine,
    DateSelect
  },
  props: {
    defaultDateValue: {
      type: String as PropType<string>,
      default: () => {
        let tmp = new Date()
        tmp.setDate(tmp.getDate() - 7)
        return tmp.toISOString().split('T')[0]; 
      },
    },
  },
  setup(props, context) {
    const storeUseList = ref<itemHierarchyUseList>([['StoreShelve', 'Store']])
    // 当日時点で営業中、または1週間以内に開店する店舗を表示する
    const storeValidData = [addDayYMD(0), addDayYMD(7)]
    const itemStoreUseList = ref<itemHierarchyUseList>([
      ['Chubunrui', 'Shobunrui', 'Class'],
    ])

    const extractConditionOfDate = ref<dateSelectExtractCondition>({})
    extractConditionOfDate.value.dateSelect = props.defaultDateValue

    const extractConditionOfStore = ref<itemHierarchyGroupExtractCondition>({})
    const extractConditionOfItemStore = ref<itemHierarchyGroupExtractCondition>({})

    const changeExtractCondition = () => {
      const cond: OrderBudgetCreateExtractCondition = {
        storeShelve: extractConditionOfStore.value.storeShelve || [],
        storeShelveCount: extractConditionOfStore.value.storeShelveCount || 0,
        store: extractConditionOfStore.value.store || [],
        storeCount: extractConditionOfStore.value.storeCount || 0,
        itemStore: {
          chubunrui: extractConditionOfItemStore.value.chubunrui || [],
          chubunruiCount: extractConditionOfItemStore.value.chubunruiCount || 0,
          shobunrui: extractConditionOfItemStore.value.shobunrui || [],
          shobunruiCount: extractConditionOfItemStore.value.shobunruiCount || 0,
          class: extractConditionOfItemStore.value.class || [],
          classCount: extractConditionOfItemStore.value.classCount || 0,
        },
        dateSelect: extractConditionOfDate.value.dateSelect || '',
      }
      context.emit('change-extract-condition', cond)
    }

    const isDateSelected = ref(false)
    const startDay = ref("")
    const endDay = ref("")
    const isFuture = ref(false)
    const updateSelectDate = (params?: string) => {
        if(params  != null){
          isDateSelected.value = true
          const selectedDay = new Date(`${params}T00:00:00`)
          const day = new Date(selectedDay)
          if(day.getDay() != 1){
            let delta = 0
            if( day.getDay() < 1){
              delta = 6
            }else{
              delta = day.getDay() - 1
            }
            day.setDate(day.getDate() - delta);
          }
          startDay.value = day.toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit",
          day: "2-digit"}).replaceAll('-', '/') + " (月)"
          day.setDate(day.getDate() +6);
          endDay.value = day.toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit",
          day: "2-digit"}).replaceAll('-', '/') + " (日)"

          const today = new Date()
          today.setHours(0, 0, 0, 0)
          isFuture.value = day > today
        }else{
          isDateSelected.value = false
          isFuture.value = false
        }
    }
    setTimeout(() => {
      updateSelectDate(extractConditionOfDate.value.dateSelect)
    },100)

    const changeExtractConditionOfDate = (
      params: dateSelectExtractCondition
    ) => {
      extractConditionOfDate.value = params
      updateSelectDate(params.dateSelect)
      changeExtractCondition()
    }
    const changeExtractConditionOfStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfStore.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfItemStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfItemStore.value = params
      changeExtractCondition()
    }

    const requiredItemInput = [
      '中分類：常に入力',
      '店舗エリア・店舗・小分類・クラスは任意の絞り込み',
    ]
    return {
      requiredItemInput,
      storeUseList,
      storeValidData,
      itemStoreUseList,
      changeExtractConditionOfStore,
      changeExtractConditionOfItemStore,
      changeExtractConditionOfDate,
      updateSelectDate,
      isDateSelected,
      startDay,
      endDay,
      isFuture
    }
  },
})
